module.exports = __webpack_public_path__ + "static/media/warning-light-hexagon.3eb6c582.svg";